module.exports = __webpack_public_path__ + "media/images/t-superior-lithographics-square-63fbc239461a1b3f4c0c307350678506.png";